/*eslint-disable*/
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useDispatch, useMappedState } from "redux-react-hook";
import axios from 'axios'

import { Frame, Text, Checkbox, H, P, H1 } from '../../UIKit/styled-templates'
import Button from '../../UIKit/Button'
import Input from '../../UIKit/Input'
import Form from '../../UIKit/Form'
import CommonHelper from '../../../helpers/CommonHelper'
import Circles from '../tools/Circles'
import * as usersActions from '../../../redux/actions/UsersActions'
import useDictionary from '../helpers/useDictionary'

let LoginFields = [
    { name: `Email`, type: `string` },
]

let RecoverPasswordPage = (props) => {

    const dispatch = useDispatch();
    let { getText } = useDictionary()

    let [tempData, setTempData] = useState({})
    let [remember, setRemember] = useState(false)

    return (
        <Wrapper>
            <Frame extra={`position: absolute; top: -230px; left: -159px;`} ><Circles width={460} /></Frame>
            <Frame extra={`position: absolute; top: 571px; left: 1400px;`} ><Circles width={480} /></Frame>
            <Header>
                <Logo onClick={() => { CommonHelper.linkTo(`/`) }} />
            </Header>
            <FormWrapper>
                <Title>{getText(`Forgot your password?`)}</Title>
                <Form
                    fields={LoginFields}
                    data={tempData}
                    onChange={(key, value) => { setTempData({ ...tempData, [key]: value }) }}
                />
                <Button extra={`width: 540px; margin-top: 20px; @media only screen and (max-width: 600px) { width: 90vw; margin-bottom: 5vw; }`} background={props => props.theme.green} onClick={() => {
                    dispatch(usersActions.logIn(tempData)).then(pld => {
                        // console.log('pld = ', pld);
                        CommonHelper.linkTo(`/`)
                        if (pld.error !== undefined) {
                            window.alert(pld.error.message);
                        }
                    })
                }} >{getText(`Send me reset password`)}</Button>
                {/* <Text
                    text_color={props => props.theme.text.support}
                    extra={`margin-top: 27px; font-size: 14px; text-transform: uppercase; cursor: pointer; text-decoration: underline;`}
                >
                    {getText(`Didn't receive confirmation instructions?`)}
                </Text> */}
            </FormWrapper>
        </Wrapper >
    )
}

const Title = styled(H)`
    color: ${props => props.theme.text.secondary};
    @media only screen and (max-width: 600px) {
        margin: 10vw 0 4vw 0;
        width: 80vw;
        text-align: center;
    };
`;

let Arrow = styled.img.attrs((props) => {
    let img
    try { img = require(`../../../assets/images/arrow_${props.color}.svg`) } catch (error) { }
    return ({ src: img, })
})`
    width: 16px;
    height: 16px;
    margin-left: 8px;
`

const FormWrapper = styled(Frame)`
    margin-top: 100px;
`;

let Logo = styled.img.attrs((props) => {
    let img
    try { img = require('../../../assets/images/rtu_logo_green.svg') } catch (error) { }
    return ({ src: img, })
})`
    width: 174.93px;
    height: 50px;
    cursor: pointer;

    @media only screen and (max-width: 600px) {
        width: 17vw;
    }
`

const Header = styled(Frame)`
    width: 730px;
    flex-direction: row;
    margin-top: 40px;
`;

const Wrapper = styled(Frame)`
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: ${props => props.theme.background.primary};
    justify-content: flex-start;
    position: relative;
`;

export default RecoverPasswordPage;
/*eslint-enable*/